/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const plusCircleFilled = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M2 12C2 6.44444 6.44444 2 12 2C17.5556 2 22 6.44444 22 12C22 17.5556 17.5556 22 12 22C6.44444 22 2 17.5556 2 12ZM13 11V7H11V11H7V13H11V17H13V13H17V11H13Z" />
	</SVG>
);

export default plusCircleFilled;
